export default {
  getGuid() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
  },
  getFileName(file) {
    let type
    if (file.type.indexOf("image") != -1){
      type = "images"
    }else if (file.type.indexOf("video") != -1){
      type = "videos"
    }else {
      type = "files"
    }
    let date = new Date;
    let y = date.getFullYear();
    let m = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
    let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

    let last = file.name.substr(file.name.lastIndexOf("."), file.name.length)
    let fileName = type + '/' + y + '/' + m + '/' + d + '/' + 'oss_' + this.getGuid() + last;

    return fileName
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js